import React from "react";
import { useNavigate } from "react-router-dom";
import { can, canAny, isSuperAdmin, useAccess } from "../../permissions/access";
import { getUserSession } from "../../function/AuthStorage";
import "./AccessDenied.css";

export function getUserPermissions() {
  return getUserSession()?.permissions || [];
}

export function getUserType() {
  return getUserSession()?.userType || null;
}

export function hasPermission(permission) {
  return can(permission);
}

export function hasAnyPermission(permissions) {
  return canAny(permissions);
}

export const ACCESS_DENIED_MESSAGE = "ليس لديك صلاحية للوصول إلى هذه الصفحة.";

/** شاشة الرفض عند فتح رابط مباشر لصفحة غير مصرح بها — لا تُحمَّل بيانات الصفحة. */
export function AccessDenied() {
  const navigate = useNavigate();
  return (
    <div className="access-denied" role="alert" data-testid="access-denied">
      <div className="access-denied__icon" aria-hidden="true">
        <i className="fa-light fa-lock-keyhole" />
      </div>
      <h2>{ACCESS_DENIED_MESSAGE}</h2>
      <p>إن كنت تحتاج هذه الصفحة في عملك فتواصل مع مسؤول النظام.</p>
      <button type="button" className="access-denied__back" onClick={() => navigate(-1)}>
        رجوع
      </button>
    </div>
  );
}

/**
 * حماية المسار: إن لم توجد الصلاحية لا تُرسم الصفحة إطلاقاً (فلا تُستدعى بياناتها)،
 * وتظهر رسالة الرفض مكانها.
 *
 * Props:
 *   adminOnly  - لمدير النظام فقط
 *   permission - صلاحية واحدة
 *   anyOf      - تكفي واحدة منها
 */
export default function PermissionRoute({ permission, anyOf, adminOnly = false, children }) {
  useAccess(); // يعيد الرسم إن سُحبت الصلاحية أثناء فتح الصفحة

  let allowed;
  if (adminOnly) allowed = isSuperAdmin();
  else if (isSuperAdmin()) allowed = true;
  else if (permission) allowed = can(permission);
  else if (anyOf && anyOf.length > 0) allowed = canAny(anyOf);
  else allowed = false;

  return allowed ? children : <AccessDenied />;
}
